document.addEventListener('DOMContentLoaded', function() {

  if (window.myProductCardScriptLoaded) {
    return;
  }
  window.myProductCardScriptLoaded = true;

  initProductCards();

  var sectionSelectors = [
    'recently-viewed.section',
    'product-recommendations.section',
    'complementary-product-recommendations.section'
  ];

  sectionSelectors.forEach(function(selector) {
    var container = document.querySelector(selector);
    if (!container || container.querySelector('product-card')) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(addedNode) {
          if (addedNode.nodeType !== 1) return;
          if (
            (addedNode.matches && addedNode.matches('product-card')) ||
            (addedNode.querySelector && addedNode.querySelector('product-card'))
          ) {
            initProductCards();
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});

function initProductCards() {
    var newCards = document.querySelectorAll('product-card:not([data-initialized])');
  
    newCards.forEach(function(card) {
      card.setAttribute('data-initialized', 'true');
  
      var hoverPreview = card.querySelector('.hover-preview');
      var swatchContainer = card.querySelector('.related-swatch-slider__container');
      if (!hoverPreview || !swatchContainer) return;
  
      var currentImage = '';
      swatchContainer.addEventListener('mouseover', function(event) {
        var swatch = event.target.closest('.related-swatch-slider__item');
        if (!swatch) return;
        if (swatch.classList.contains('related-swatch-slider__item--current')) {
          hoverPreview.style.display = 'none';
          currentImage = '';
          return;
        }
        var hoverImageUrl = swatch.getAttribute('data-hover-image');
        if (hoverImageUrl && hoverImageUrl !== currentImage) {
          hoverPreview.querySelector('img').src = hoverImageUrl;
          hoverPreview.style.display = 'block';
          currentImage = hoverImageUrl;
        }
      });
  
      swatchContainer.addEventListener('mouseleave', function() {
        hoverPreview.style.display = 'none';
        currentImage = '';
      });
    });
  }